import React from "react";
import Modal from "react-modal";
import styled from "styled-components";
import { injectIntl } from "react-intl";

const style = {
  overlay: {
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 5,
    backgroundColor: "rgba(255, 255, 255, 0.75)",
  },
  content: {
    position: "static",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 0px 30px 4px rgba(0,0,0,0.10)",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "0px",
    width: "700px",
    marginLeft: "10px",
    marginRight: "10px",
  },
};

const HeadingWrapper = styled.div`
  background: ${(p) => p.theme.colors[p.color]};
  color: ${(p) => p.theme.colors.on[p.color]};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  position: relative;
`;

const Heading = styled.h2`
  margin: 0;
  text-transform: uppercase;
`;

const P = styled.div`
  padding: 40px 20px;
  text-align: center;
`;

const ButtonsWrapper = styled.div`
  padding: 0 15px 15px 15px;
  display: flex;
  flex-direction: ${(p) => p.flexDirection};
  align-items: center;
  justify-content: center;
`;

const ConfirmBtn = styled.button`
  margin: 0 10px;
  background: ${(p) => p.theme.colors[p.color]};
  border-radius: 50px;
  border: none;
  padding: 15px 25px;
  color: ${(p) => p.theme.colors.on[p.color]};
  display: inline-block;
  text-align: center;
  font-weight: bold;
  ${(p) => (p.absolute ? "position: absolute; left: 0px;" : "")}
`;

const _Modal = injectIntl((props) => {
  const {
    intl,
    text,
    confirm,
    extraCloseButton = false,
    close = () => location.reload(),
    type = "danger",
    homeButton = false,
    flexDirection = "row",
    confirmLabel,
    closeLabel,
  } = props;
  const isPermissionedDeniedError = text === "Modal.permissionDenied";
  const heading = props.heading || "error";

  return (
    <Modal
      className="sp-portal-modal"
      isOpen={true}
      style={style}
      aria={{
        labelledby: "heading",
        describedby: "full_description",
      }}
    >
      <HeadingWrapper color={type}>
        <Heading>{heading ? intl.formatMessage({ id: heading }) : ""}</Heading>
        {extraCloseButton && (
          <ConfirmBtn
            onClick={close}
            color={type}
            absolute
            className="sp-portal-modal-extra-close-button"
          >
            {closeLabel || intl.formatMessage({ id: "Close" })}
          </ConfirmBtn>
        )}
      </HeadingWrapper>

      <P className="sp-portal-modal-content">
        <div
          dangerouslySetInnerHTML={
            text
              ? {
                  __html: text ? intl.formatMessage({ id: text }) : "",
                }
              : undefined
          }
        />
      </P>

      <ButtonsWrapper
        className="sp-portal-modal-buttons"
        flexDirection={flexDirection}
      >
        {homeButton && (
          <ConfirmBtn
            className="sp-portal-modal-home-button"
            onClick={() => (location = "/home")}
            color={type}
          >
            {intl.formatMessage({ id: "Modal.goHome" })}
          </ConfirmBtn>
        )}
        {confirm && (
          <ConfirmBtn
            className="sp-portal-modal-confirm-button"
            onClick={confirm}
          >
            {intl.formatMessage({ id: confirmLabel || "Confirm" })}
          </ConfirmBtn>
        )}
        {!isPermissionedDeniedError && (
          <ConfirmBtn
            className="sp-portal-modal-close-button"
            onClick={close}
            color={type}
          >
            {intl.formatMessage({ id: closeLabel || "Close" })}
          </ConfirmBtn>
        )}
      </ButtonsWrapper>
    </Modal>
  );
});

export default _Modal;
